module.exports = __webpack_public_path__ + "static/media/volume-tiers.01c7843e.png";